import type { TwoFactorType } from 'mmfintech-checkout-commons/types'
import { TwoFactorTypes } from 'mmfintech-checkout-commons'
import { tr } from 'mmfintech-commons'

export const getOptTitle = (twoFactorType: TwoFactorType) => {
  switch (twoFactorType) {
    case TwoFactorTypes.SMS:
      return tr('CHECKOUT.OTP.SMS_VERIFICATION', 'SMS verification')

    case TwoFactorTypes.EMAIL:
      return tr('CHECKOUT.OTP.EMAIL_VERIFICATION', 'Email verification')

    case TwoFactorTypes.TOTP:
      return tr('CHECKOUT.OTP.GA_VERIFICATION', 'Google Authenticator verification')

    default:
      return tr('CHECKOUT.OTP.EMAIL_VERIFICATION', 'Email verification')
  }
}
